import React, { useState, useEffect } from 'react';
import TrialClassSuccessModal from '../Modals/TrialClassSuccessModal';

const CustomAlerts: React.FC = () => {
  // State
  const [
    trialClassCreatedModalOpen,
    setTrialClassCreatedStartModal,
  ] = useState<boolean>(false);

  const urlParams = new URLSearchParams(window.location.search);
  const isTrialClassCreated = urlParams.has('trialClassCreated');

  useEffect(() => {
    if (isTrialClassCreated) {
      setTrialClassCreatedStartModal(true);
    }
  }, []);

  return (
    <>
      {trialClassCreatedModalOpen && (
        <TrialClassSuccessModal
          open={trialClassCreatedModalOpen}
          onClose={() => setTrialClassCreatedStartModal(false)}
        />
      )}
    </>
  );
};

export default CustomAlerts;
